import React, { useMemo } from 'react';
import FocusTrap from 'focus-trap-react';
import { VenueWithMenus } from 'components/SingleItem/Details';
import BusyMode from 'components/BusyMode/BusyMode';
import useFeatureFlagsQuery from 'common/Hooks/UseFeatureFlagsQuery';

interface Props {
  currentVenue?: VenueWithMenus | undefined;
}

const PAUSE_STORE_FEATURE_FLAG = 'pauseStoreEnabled';

const BusyModePanel: React.FC<Props> = ({ currentVenue }) => {
  const [data, loading, error] = useFeatureFlagsQuery([PAUSE_STORE_FEATURE_FLAG]);
  const isPauseStoreEnabled = useMemo(() => {
    if (loading || error || !data) {
      return false;
    }

    const pauseStoreFeatureFlag = data[PAUSE_STORE_FEATURE_FLAG];
    return pauseStoreFeatureFlag ? pauseStoreFeatureFlag.isEnabled : false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <div>
      {isPauseStoreEnabled && (
        <FocusTrap
          active
          focusTrapOptions={{
            escapeDeactivates: false,
            clickOutsideDeactivates: true
          }}
        >
          <BusyMode menus={currentVenue?.menus} venueId={currentVenue?.hashedId} venueName={currentVenue?.name} />
        </FocusTrap>
      )}
    </div>
  );
};

export default BusyModePanel;
